

(function () {
  'use strict';

  const TMH = window.TMH || {};
  if (!TMH.config) {
    console.warn('[TMH finder] config non caricato — controlla snippets/tmh-storefront-config.liquid');
    return;
  }

  const SESSION_KEY = TMH.config.sessionStorageKey;

  
  
  

  const REGIONI = [
    { slug: 'abruzzo', nome: 'Abruzzo', status: 'dormente' },
    { slug: 'basilicata', nome: 'Basilicata', status: 'dormente' },
    { slug: 'calabria', nome: 'Calabria', status: 'dormente' },
    { slug: 'campania', nome: 'Campania', status: 'dormente' },
    { slug: 'emilia-romagna', nome: 'Emilia-Romagna', status: 'dormente' },
    { slug: 'friuli-venezia-giulia', nome: 'Friuli-Venezia Giulia', status: 'dormente' },
    { slug: 'lazio', nome: 'Lazio', status: 'dormente' },
    { slug: 'liguria', nome: 'Liguria', status: 'dormente' },
    { slug: 'lombardia', nome: 'Lombardia', status: 'dormente' },
    { slug: 'marche', nome: 'Marche', status: 'dormente' },
    { slug: 'molise', nome: 'Molise', status: 'dormente' },
    { slug: 'piemonte', nome: 'Piemonte', status: 'dormente' },
    { slug: 'puglia', nome: 'Puglia', status: 'dormente' },
    { slug: 'sardegna', nome: 'Sardegna', status: 'dormente' },
    { slug: 'sicilia', nome: 'Sicilia', status: 'dormente' },
    { slug: 'toscana', nome: 'Toscana', status: 'attiva' },
    { slug: 'trentino-alto-adige', nome: 'Trentino-Alto Adige', status: 'dormente' },
    { slug: 'umbria', nome: 'Umbria', status: 'dormente' },
    { slug: 'valle-d-aosta', nome: "Valle d'Aosta", status: 'dormente' },
    { slug: 'veneto', nome: 'Veneto', status: 'dormente' },
  ];

  
  const PROVINCE_TOSCANE = [
    { targa: 'AR', nome: 'Arezzo' },
    { targa: 'FI', nome: 'Firenze' },
    { targa: 'GR', nome: 'Grosseto' },
    { targa: 'LI', nome: 'Livorno' },
    { targa: 'LU', nome: 'Lucca' },
    { targa: 'MS', nome: 'Massa-Carrara' },
    { targa: 'PI', nome: 'Pisa' },
    { targa: 'PO', nome: 'Prato' },
    { targa: 'PT', nome: 'Pistoia' },
    { targa: 'SI', nome: 'Siena' },
  ];

  
  
  

  let DATA = { facilitatori: [], mercati: [] };
  try {
    const el = document.getElementById('tmh-finder-data');
    if (el) DATA = JSON.parse(el.textContent);
  } catch (e) {
    console.error('[TMH finder] Errore parse dataset', e);
  }

  
  
  

  function getProvinceConFacilitatore() {
    // La provincia si accende dove c'e' un luogo di ritiro, non dove ha sede
    // l'ambulante: Martinelli e' di Firenze ma lavora due mercati in provincia di Siena.
    const set = new Set();
    DATA.mercati.forEach((m) => {
      if (m.provincia) set.add(m.provincia);
    });
    return set;
  }

  function getComuniProvincia(provinciaTarga) {
    const mercatiProv = DATA.mercati.filter((m) => m.provincia === provinciaTarga);
    const comuni = [...new Set(mercatiProv.map((m) => m.comune).filter(Boolean))].sort((a, b) =>
      a.localeCompare(b, 'it'),
    );
    return comuni;
  }

  function getMercatiComune(provinciaTarga, comune) {
    // Un mercato compare una volta sola, anche quando ci lavorano piu' facilitatori:
    // il dataset ne emette una copia per ogni banco, e senza questo filtro la stessa
    // piazza usciva due volte nella tendina, identica e indistinguibile.
    const visti = new Set();
    return DATA.mercati.filter((m) => {
      if (m.provincia !== provinciaTarga || m.comune !== comune) return false;
      if (visti.has(m.handle)) return false;
      visti.add(m.handle);
      return true;
    });
  }

  function getFacilitatoriByMercato(mercatoHandle) {
    // Tutti, non il primo: a Colle di Val d'Elsa e a Siena ce ne sono due,
    // e con find() il secondo spariva dal finder.
    return DATA.facilitatori.filter(
      (f) => Array.isArray(f.mercati_handles) && f.mercati_handles.includes(mercatoHandle),
    );
  }

  
  
  

  class TMHFinder {
    constructor() {
      this.radice = document.getElementById('tmh-finder');
      this.txt = (this.radice && this.radice.dataset) || {};

      this.steps = {
        regione: document.getElementById('finder-regione'),
        provincia: document.getElementById('finder-provincia'),
        comune: document.getElementById('finder-comune'),
        mercato: document.getElementById('finder-mercato'),
        ambulante: document.getElementById('finder-ambulante'),
      };
      this.result = document.getElementById('finder-result');
      this.codiceEl = document.getElementById('finder-codice');
      this.nomeEl = document.getElementById('finder-nome-ambulante');
      this.mercatoEl = document.getElementById('finder-mercato-info');
      this.btnCopia = document.getElementById('finder-copia');
      this.btnCarrello = document.getElementById('finder-carrello');

      this.stepOrder = ['regione', 'provincia', 'comune', 'mercato', 'ambulante'];
      this.state = { regione: null, provincia: null, comune: null, mercato: null, ambulante: null };

      this.populateRegioni();
      this.bind();
    }

    populateRegioni() {
      const select = this.steps.regione;
      REGIONI.forEach((r) => {
        const opt = document.createElement('option');
        opt.value = r.slug;
        opt.textContent =
          r.status === 'attiva' ? r.nome : (this.txt.finderRegioneArrivo || '').replace('[nome]', r.nome);
        opt.disabled = r.status !== 'attiva';
        select.appendChild(opt);
      });
    }

    bind() {
      this.steps.regione.addEventListener('change', () => this.onRegioneChange());
      this.steps.provincia.addEventListener('change', () => this.onProvinciaChange());
      this.steps.comune.addEventListener('change', () => this.onComuneChange());
      this.steps.mercato.addEventListener('change', () => this.onMercatoChange());
      this.steps.ambulante.addEventListener('change', () => this.onAmbulanteChange());

      if (this.btnCopia) this.btnCopia.addEventListener('click', () => this.copyCodice());
      if (this.btnCarrello) this.btnCarrello.addEventListener('click', () => this.goToCart());
    }

    onRegioneChange() {
      this.state.regione = this.steps.regione.value;
      this.resetFrom('provincia');
      if (!this.state.regione) return;

      
      if (this.state.regione === 'toscana') {
        const provinceConFac = getProvinceConFacilitatore();
        PROVINCE_TOSCANE.forEach((p) => {
          const opt = document.createElement('option');
          opt.value = p.targa;
          const hasFac = provinceConFac.has(p.targa);
          opt.textContent = hasFac
            ? p.nome
            : (this.txt.finderProvinciaSenza || '').replace('[nome]', p.nome);
          opt.disabled = !hasFac;
          this.steps.provincia.appendChild(opt);
        });
        this.enableStep('provincia');
      }
    }

    onProvinciaChange() {
      this.state.provincia = this.steps.provincia.value;
      this.resetFrom('comune');
      if (!this.state.provincia) return;

      const comuni = getComuniProvincia(this.state.provincia);
      comuni.forEach((c) => {
        const opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        this.steps.comune.appendChild(opt);
      });
      this.enableStep('comune');
    }

    onComuneChange() {
      this.state.comune = this.steps.comune.value;
      this.resetFrom('mercato');
      if (!this.state.comune) return;

      const mercati = getMercatiComune(this.state.provincia, this.state.comune);
      mercati.forEach((m) => {
        const opt = document.createElement('option');
        opt.value = m.handle;
        const label = m.title + (m.frequenza ? ' · ' + m.frequenza : '');
        opt.textContent = label;
        this.steps.mercato.appendChild(opt);
      });
      this.enableStep('mercato');
    }

    onMercatoChange() {
      this.state.mercato = this.steps.mercato.value;
      this.resetFrom('ambulante');
      if (!this.state.mercato) return;

      const facilitatori = getFacilitatoriByMercato(this.state.mercato);
      if (facilitatori.length) {
        facilitatori.forEach((f) => {
          const opt = document.createElement('option');
          opt.value = f.codice;
          opt.textContent = (this.txt.finderFacilitatore || '').replace('[nome]', f.nome);
          this.steps.ambulante.appendChild(opt);
        });
        this.enableStep('ambulante');

        // Con un banco solo la scelta non esiste: si sceglie da se'.
        // Con due o piu' decide chi ordina, e la tendina resta aperta.
        if (facilitatori.length === 1) {
          this.steps.ambulante.value = facilitatori[0].codice;
          this.onAmbulanteChange();
        }
      }
    }

    onAmbulanteChange() {
      this.state.ambulante = this.steps.ambulante.value;
      if (!this.state.ambulante) {
        this.result.style.display = 'none';
        return;
      }

      const fac = DATA.facilitatori.find((f) => f.codice === this.state.ambulante);
      const mercato = DATA.mercati.find((m) => m.handle === this.state.mercato);

      if (!fac || !mercato) return;

      this.codiceEl.textContent = fac.codice;
      this.nomeEl.textContent = fac.nome;
      this.mercatoEl.innerHTML = (this.txt.finderMercatoScelto || '')
        .replace('[mercato]', this.escapeHtml(mercato.title))
        .replace('[comune]', this.escapeHtml(mercato.comune))
        .replace('[provincia]', this.escapeHtml(mercato.provincia));
      this.result.style.display = 'block';

      
      try {
        sessionStorage.setItem(SESSION_KEY, fac.codice);
      } catch (e) {
        
      }

      
      this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    resetFrom(stepName) {
      const idx = this.stepOrder.indexOf(stepName);
      for (let i = idx; i < this.stepOrder.length; i++) {
        const key = this.stepOrder[i];
        const sel = this.steps[key];
        const placeholder = sel.querySelector('option[value=""]');
        sel.innerHTML = '';
        if (placeholder) sel.appendChild(placeholder);
        sel.disabled = true;
        sel.value = '';
        const wrap = document.querySelector(`[data-step-wrap="${key}"]`);
        if (wrap) wrap.classList.add('is-disabled');
        this.state[key] = null;
      }
      this.result.style.display = 'none';
    }

    enableStep(stepName) {
      const sel = this.steps[stepName];
      sel.disabled = false;
      const wrap = document.querySelector(`[data-step-wrap="${stepName}"]`);
      if (wrap) wrap.classList.remove('is-disabled');
    }

    copyCodice() {
      const codice = this.codiceEl.textContent;
      const setCopied = () => {
        const original = this.btnCopia.innerHTML;
        this.btnCopia.textContent = this.txt.finderCopiato || '';
        setTimeout(() => {
          this.btnCopia.innerHTML = original;
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(codice)
          .then(setCopied)
          .catch(() => setCopied());
      } else {
        
        const tmp = document.createElement('input');
        tmp.value = codice;
        document.body.appendChild(tmp);
        tmp.select();
        try {
          document.execCommand('copy');
          setCopied();
        } catch (e) {}
        document.body.removeChild(tmp);
      }
    }

    goToCart() {
      window.location.href = this.txt.finderCartUrl || '/cart';
    }

    escapeHtml(s) {
      return String(s || '').replace(
        /[&<>"']/g,
        (c) =>
          ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
          })[c],
      );
    }
  }

  function init() {
    if (document.getElementById('tmh-finder')) {
      new TMHFinder();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
